import { readFileSync, readdirSync } from 'fs';
import htmlToDocx from 'html-to-docx';
import JSZip from 'jszip';
import juice from 'juice';
import { join } from 'path';



import matter from 'gray-matter';

interface Article {
  slug?: string;
  content?: string;
}

const articlesDirectory = join(process.cwd(), '_docs');

export const getArticleSlugs = (): string[] => {
  return readdirSync(articlesDirectory);
};

export const getArticleBySlug = (slug: string, fields: string[] = []): Article => {
  const realSlug = slug.replace(/\.md$/, '');
  const fullPath = join(articlesDirectory, `${realSlug}.md`);
  const fileContents = readFileSync(fullPath, 'utf8');
  const { data, content } = matter(fileContents);

  const items = {};

  fields.forEach((field) => {
    if (field === 'slug') {
      items[field] = realSlug;
    }

    if (field === 'content') {
      items[field] = content;
    }

    if (data[field]) {
      items[field] = data[field];
    }
  });

  return items;
};

export const getArticles = (fields: string[] = []): Article[] => {
  const slugs = getArticleSlugs();

  return slugs.map((slug) => getArticleBySlug(slug, fields));
};

export const Export2DocOptimizedArticle = async (html, fileName) => {
  // console.log('Export2DocOptimizedArticle', html);
    //replace blockquote with span
    html = html.replace(/<blockquote[^>]*>/g, "<div>");
    html = html.replace(/<\/blockquote>/g, "</div>");
    //remove img tags
    html = html.replace(/<img[^>]*>/g, "");

  const styles = `
div p {
color: #6a00ff !important;
}

div h2, div h3, div h4, div h5, div h6 {
color: #6a00ff !important;
}

div a {
color: #6a00ff !important;
}

div ul {
color: #6a00ff !important;
}

div ol {
color: #6a00ff !important;
}

div li {
color: #6a00ff !important;
}



`;


let htmlWithStyles = juice.inlineContent(html, styles, { applyStyleTags: true });
  // remov/e divs
  // htmlWithStyles = htmlWithStyles.replace(/<div[^>]*>/g, '');
  // htmlWithStyles = htmlWithStyles.replace(/<\/div>/g, '');



  // console.log('Export2DocOptimizedArticle', htmlWithStyles);

  try {


    const buffer = await htmlToDocx(htmlWithStyles, undefined, JSZip);


    if (buffer) {
      const url = window.URL.createObjectURL(
        new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }),
      );

      const linkElement = document.createElement('a');
      linkElement.href = url;
      linkElement.download = `${fileName}.docx`;

      document.body.appendChild(linkElement);




      linkElement.click();

      document.body.removeChild(linkElement);
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      return false;
      throw new Error('Failed to convert HTML to DOCX');

    }




  } catch (error) {
    return false;
  }
}

export const Export2Docx = async (html, fileName) => {
  try {
   const buffer = await htmlToDocx(html, undefined, JSZip);
  if (buffer) {
      const url = window.URL.createObjectURL(
        new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }),
      );

      const linkElement = document.createElement('a');
      linkElement.href = url;
      linkElement.download = `${fileName}.docx`;
      document.body.appendChild(linkElement);
      linkElement.click();
      document.body.removeChild(linkElement);
      window.URL.revokeObjectURL(url);
    } else {
      throw new Error('Failed to convert HTML to DOCX');
    }
  } catch (error) {
    console.error(error);
  }
}